export default __webpack_public_path__ + "static/media/mittelbaden_light.14567f4e.png";